var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        title: _vm.$t("operation.business_detail"),
        width: "640px",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-descriptions",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: { column: 1, border: "" },
        },
        [
          _c(
            "el-descriptions-item",
            { attrs: { label: _vm.$t("operation.business_no") } },
            [_vm._v(_vm._s(_vm.detail.business_no || "-"))]
          ),
          _c(
            "el-descriptions-item",
            { attrs: { label: _vm.$t("operation.business_name") } },
            [_vm._v(_vm._s(_vm.detail.business_name || "-"))]
          ),
          _c(
            "el-descriptions-item",
            { attrs: { label: _vm.$t("operation.business_type") } },
            [_vm._v(_vm._s(_vm.getBusinessTypeLabel(_vm.detail.business_type)))]
          ),
          _c(
            "el-descriptions-item",
            { attrs: { label: _vm.$t("operation.business_region") } },
            [_vm._v(_vm._s(_vm.detail.country_code || "-"))]
          ),
          _c(
            "el-descriptions-item",
            { attrs: { label: _vm.$t("operation.business_currency") } },
            [_vm._v(_vm._s(_vm.detail.currency || "-"))]
          ),
          _c(
            "el-descriptions-item",
            { attrs: { label: _vm.$t("operation.related_franchisee") } },
            [_vm._v(_vm._s(_vm.franchiseeInfo))]
          ),
          _c(
            "el-descriptions-item",
            { attrs: { label: _vm.$t("operation.description") } },
            [_vm._v(_vm._s(_vm.detail.description || "-"))]
          ),
          _c(
            "el-descriptions-item",
            { attrs: { label: _vm.$t("operation.create_time") } },
            [_vm._v(_vm._s(_vm.detail.create_time || "-"))]
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("components.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }